import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddMoreResourcesCardComponent } from './components/add-more-resources-card/add-more-resources-card.component';
import { AddMoreResourcesModalComponent } from './modals/add-more-resources-modal/add-more-resources-modal.component';
import { ManageSubscriptionsComponent } from './components/manage-subscriptions/manage-subscriptions.component';
import { ResourceInformationComponent } from './components/resource-information/resource-information.component';
import { StatsAndResourcesComponent } from './components/stats-and-resources/stats-and-resources.component';
import { UnavailableFeatureComponent } from './components/unavailable-feature/unavailable-feature.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { NewVersionAvailableComponent } from './modals/new-version-available/new-version-available.component';
import { PrivacyPolicyModalComponent } from './modals/privacy-policy-modal/privacy-policy-modal.component';
import { UnavailableFeatureModalComponent } from './modals/unavailable-feature-modal/unavailable-feature-modal.component';
import { UnavailableFindDeviceModalComponent } from './modals/unavailable-find-device-modal/unavailable-find-device-modal.component';
import { UnavailableTeamsModalComponent } from './modals/unavailable-teams-modal/unavailable-teams-modal.component';
import { SharedModule } from '@shared/shared.module';
import { StatsCardComponent } from './components/stats-card/stats-card.component';
import { ConvertToPipe } from './pipes/convert-to.pipe';
import { ShareWithUserModal } from './modals/share-with-user-modal/share-with-user-modal.component';

@NgModule({
  declarations: [
    UserAvatarComponent,
    AddMoreResourcesCardComponent,
    ManageSubscriptionsComponent,
    ResourceInformationComponent,
    StatsAndResourcesComponent,
    UnavailableFeatureComponent,

    PrivacyPolicyModalComponent,
    NewVersionAvailableComponent,
    AddMoreResourcesModalComponent,
    UnavailableFeatureModalComponent,
    UnavailableFindDeviceModalComponent,
    UnavailableTeamsModalComponent,
    StatsCardComponent,
    ConvertToPipe,
    ShareWithUserModal
  ],
  exports: [
    UserAvatarComponent,
    AddMoreResourcesCardComponent,
    ManageSubscriptionsComponent,
    ResourceInformationComponent,
    StatsAndResourcesComponent,
    UnavailableFeatureComponent,
    StatsCardComponent,

    PrivacyPolicyModalComponent,
    NewVersionAvailableComponent,
    AddMoreResourcesModalComponent,
    UnavailableFeatureModalComponent,
    UnavailableFindDeviceModalComponent,
    UnavailableTeamsModalComponent,
    ConvertToPipe,
    ShareWithUserModal
  ],
  providers: [ ConvertToPipe ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class AccountSharedModule {
  
}
